import { useEffect, useRef } from "react";
import { runWithdrawalOfficialAppPrompt } from "./controller";

const WITHDRAW_TAB_INDEX = 2;

export const useWithdrawalEntryPrompt = (
  activeTab: number,
  userId?: string | number | null,
) => {
  const previousTabRef = useRef<number>();

  useEffect(() => {
    const previousTab = previousTabRef.current;
    previousTabRef.current = activeTab;

    if (previousTab !== WITHDRAW_TAB_INDEX && activeTab === WITHDRAW_TAB_INDEX) {
      void runWithdrawalOfficialAppPrompt({
        stage: "enter_withdraw",
        userId,
      });
    }
  }, [activeTab, userId]);
};
